import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  found: {
    id: 'resultsheader.searchdescription.found',
    description: 'The number of providers returned for the search',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found`
  },
  foundfornear: {
    id: 'resultsheader.searchdescription.foundfornear',
    description:
      'The number of providers returned for the search for a given search term near a location',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found for {searchTerm} near {location}`
  },
  foundfor: {
    id: 'resultsheader.searchdescription.foundfor',
    description:
      'The number of providers returned for the search for a given search term',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found for {searchTerm}`
  },
  foundForRefined: {
    id: 'resultsheader.searchdescription.foundfor-refined',
    description:
      'The number of providers returned for the search for a given search term',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found filtered from {searchTerm}`
  },
  foundnear: {
    id: 'resultsheader.searchdescription.foundnear',
    description:
      'The number of providers returned for the search near a location',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found near {location}`
  },
  clearfilters: {
    id: 'resultsheader.clearfilters',
    description: 'Button text to clear all previously selected filters',
    defaultMessage: 'Clear All Filters'
  },
  locationName: {
    id: 'mapsearch.providerdrawer.selectedlocation',
    description: 'Map search provider drawer selected location name',
    defaultMessage: ' at {location}'
  },
  pmaUrlPreText: {
    id: 'pma.url.pretext',
    description: 'To make provider updates visit',
    defaultMessage: 'To make provider updates visit'
  },
  pmaUrlLabel: {
    id: 'pma.url.label',
    description: 'ProviderMatch Admin',
    defaultMessage: 'ProviderMatch Admin'
  },
  startNewSearch: {
    id: 'search.listing.start_a_new_search',
    description: 'Link to start a new search',
    defaultMessage: 'Start a new search'
  },
  searchHomeFilters: {
    id: 'search.home.filters',
    description:
      'Message displayed when search home with filters config is used',
    defaultMessage:
      'Your results are being filtered based on defaults chosen by your health system. Use the {clearAllFilters} link to show all providers.'
  },
  noapptpurposes: {
    id: 'error.no_appointment_purposes',
    description: 'Error for when the provider does not accept online booking',
    defaultMessage:
      'Sorry! {provider_name} does not accept {patient_status} patients via online booking.'
  },
  noapptpurposesGlobal: {
    id: 'error.no_appointment_purposes.global',
    description: 'Error for when all providers do not accept online booking',
    defaultMessage:
      "Sorry! We can't find any providers who accept {patient_status} patients via online booking."
  },
  noBookOnlineAvailabilityWarning: {
    id: 'provider.profile.apptInfo.noBookOnlineAvailabilitylWarning',
    description: 'Text to be displayed when a location has no availability',
    defaultMessage:
      'No online appointments available for {location}, call to schedule.'
  },
  establishedPatientType: {
    id: 'patient.established',
    description: 'Established patient type',
    defaultMessage: 'established'
  },
  newPatientType: {
    id: 'patient.new',
    description: 'New patient type',
    defaultMessage: 'new'
  },
  searchIsTooGeneralAriaLive: {
    id: 'search.searchIsTooGeneral',
    description: 'Aria live message to help guide users to refine a search',
    defaultMessage: 'Your search for {term} might be too general.'
  },

  /* Meta attributes */
  // Search
  metaSearchPageTitleBasic: {
    id: 'providerlist.pagetitle.basic',
    description: 'The title of the page containing search results',
    defaultMessage: 'ProviderMatch'
  },
  metaSearchPageTitleWithQuery: {
    id: 'providerlist.pagetitle.withquery',
    description: 'The title of the page containing search results',
    defaultMessage: '{searchTerm} - ProviderMatch'
  },
  metaSearchPageTitleWithQueryAndLocation: {
    id: 'providerlist.pagetitle.withqueryandlocation',
    description: 'The title of the page containing search results',
    defaultMessage: '{searchTerm} in {location} - ProviderMatch'
  },
  metaSearchPageDescriptionBasic: {
    id: 'providerlist.pagedescription.basic',
    description: 'The description of the page containing search results',
    defaultMessage: 'ProviderMatch'
  },
  metaSearchPageDescriptionWithQuery: {
    id: 'providerlist.pagedescription.withquery',
    description: 'The description of the page containing search results',
    defaultMessage: '{searchTerm} - ProviderMatch'
  },
  // Location
  metaLocationTitle: {
    id: 'location.title',
    description: 'Page title for the location',
    defaultMessage: '{name} - {city} - {state} - {locationType}'
  },
  metaLocationDescription: {
    id: 'location.description',
    description: 'Page description for the location',
    defaultMessage:
      '{name}. {address} - {locationType} Services: {serviceNames} Specialties: {specialtyNames}'
  },
  // Map Search
  metaMapSearchPageTitle: {
    id: 'pmc.mapsearch.pagetitle',
    description: 'Page title for map-search',
    defaultMessage: '{searchDescription} - Map - ProviderMatch'
  },
  metaMapSearchPageTitleNoSearch: {
    id: 'pmc.mapsearch.pagetitle.noSearch',
    description: 'Page title for map-search without a search',
    defaultMessage: 'Map - ProviderMatch'
  },
  // Profile
  metaProfileDoctorName: {
    id: 'provider.profile.description.doctorname',
    description: "A page description for the doctor's name and title",
    defaultMessage: 'Dr. {providerName}'
  },
  metaProfileBasicProviderStatement: {
    id: 'provider.profile.description.statement',
    description: "Page description for the provider's profile",
    defaultMessage:
      'Find information about and book an appointment with {providerName}.'
  },
  metaProfileBasicProviderStatementLocation: {
    id: 'provider.profile.description.statementlocation',
    description: "Page description for the provider's profile with locations",
    defaultMessage:
      'Find information about and book an appointment with {providerName} in {displayLocations}.'
  },
  metaProfileDescriptionLocations: {
    id: 'provider.profile.description.locations',
    description: "Page description for the doctor's locations",
    defaultMessage: 'Practice Locations: {displayLocations}.'
  },
  metaProfileDescriptionSpecialties: {
    id: 'provider.profile.description.specialties',
    description: "Page description for the doctor's locations",
    defaultMessage: 'Specialties: {specialties}.'
  },
  // Search Sorting
  bestmatch: {
    id: 'sortdropdown.bestmatch',
    description: 'Option for a relevance sort',
    defaultMessage: 'Best Match'
  },
  distance: {
    id: 'sortdropdown.distance',
    description: 'Option for a distance sort',
    defaultMessage: 'Distance'
  },
  availability: {
    id: 'sortdropdown.availability',
    description: 'Option for an availability sort (density)',
    defaultMessage: 'Availability'
  },
  availabilitysoonest: {
    id: 'sortdropdown.availabilitysoonest',
    description: 'Option for an availability sort (soonest)',
    defaultMessage: 'Availability'
  },
  alphabetical: {
    id: 'sortdropdown.alphabetical',
    description: 'Option for an alphabetical sort',
    defaultMessage: 'A-Z'
  },
  reversealphabetical: {
    id: 'sortdropdown.reversealphabetical',
    description: 'Option for a reverse-alphabetical sort',
    defaultMessage: 'Z-A'
  },
  sortby: {
    id: 'resultsheader.sortby',
    description: 'Header for a sort dropdown',
    defaultMessage: 'Sort'
  },
  sortarialabel: {
    id: 'resultsheader.sortbyarialabel',
    description: 'Header for Sorting options region',
    defaultMessage: 'Sorting options'
  },
  clearSortAriaLabel: {
    id: 'resultsheader.clearsortarialabel',
    description: 'Aria label for button to clear sort selection',
    defaultMessage: 'Clear sort selection'
  },
  searchFilterDrawerTitle: {
    id: 'search.filter_drawer.title',
    description: 'search filter drawer title',
    defaultMessage: 'Filter'
  },
  searchFilterDrawerViewResults: {
    id: 'search.filter_drawer.view_results',
    description: 'search filter drawer view results',
    defaultMessage: 'View Results'
  },
  clearButton: {
    id: 'search.filter_drawer.clear_button',
    description: 'text for the clear button',
    defaultMessage: 'Clear all'
  }
});
